import { Navigate, Route, Routes } from 'react-router-dom';
import { RouteKey } from './AppRoutes';
import { MandantLayout } from '../layout/MandantLayout';
import { MandantPage } from './tenant/MandantPage';
import { DashboardPage } from './dashboard/DashboardPage';
import { RouteGuardAuthorizedKeycloak } from './RouteGuardAuthorizedKeycloak';
import LoginPage from './LoginPage';
import { UserPage } from "./user/UserPage";
import { EditProfilePage } from './user/EditProfilePage';
import { EditUserPage } from "./user/EditUserPage";

export function AppRouter() {
  return (
    <Routes>
      <Route element={<MandantLayout />}>
        <Route element={<RouteGuardAuthorizedKeycloak />}>
          <Route
            path={RouteKey.HOME}
            element={<Navigate to={RouteKey.DASHBOARD} replace />}
          />
          <Route path={RouteKey.DASHBOARD} element={<DashboardPage />} />
          <Route path={RouteKey.User} element={<UserPage />} />
          <Route path={RouteKey.NewMandant} element={<MandantPage />} />
          <Route path={RouteKey.EditProfile} element={<EditProfilePage />} />
          <Route path={RouteKey.EditUser} element={<EditUserPage />} />
        </Route>
        <Route path={RouteKey.LOGIN} element={<LoginPage />} />
      </Route>
    </Routes>
  );
}
